import React from 'react';
import { formatDate } from '@/util/dateUtils';

/**
 * 날짜 셀 컴포넌트
 * 
 * 날짜를 포맷팅하여 표시합니다.
 * 
 * @param {Object} params - DataGrid의 renderCell 파라미터
 * @param {Object} params.row - 행 데이터
 * @param {string} params.row[dateField] - 날짜 필드 값
 * @param {string} dateField - 날짜 필드명
 */
const DateCell = ({ row, dateField }) => {
  return formatDate(row[dateField]) || '-';
};

export default DateCell;
